export default __webpack_public_path__ + "static/media/Montserrat-Bold.165ff0f4.otf";